module.exports = (promoCode) => `
  mutation {
    removePromotionFromCurrentOrder(promoCode: "${promoCode}") {
      number
      state
      currency
      displayTotal
      isRegistrationValid
      isShippingValid
      isPaymentValid
      isTaxIncluded
      adyenTotalAmount
      items {
        sku
        variantId
        color
        groupName
        imageUrl
        price
        productPath
        productType
        quantity
        size
        stock
      }
      promotionAdjustment {
        code
        amount
        currency
      }
      taxAdjustments {
        label
        amount
        type
      }
      shippingRates {
        id
        name
        price
        displayPrice
        selected
        estimatedDelivery
        notice
      }
    }
  }
`
